module.exports = __webpack_public_path__ + "static/img/Spotify.93762157.png";